export default "__VITE_ASSET__DLGs_BwK__"